import { useContextConsumer } from "../../context/Providers/ContextProvider";
import { LoggingMode } from "../../context/types/LoggingMode";
import { AuthenticationMode } from "../application/types/AuthenticationMode";

export const useAuthenticationMode = () => {
  const { loggingInMode } = useContextConsumer();

  if (
    loggingInMode.includes(LoggingMode.Local) &&
    !loggingInMode.includes(LoggingMode.Sso) &&
    !loggingInMode.includes(LoggingMode.Guest)
  ) {
    return AuthenticationMode.Local;
  }

  if (
    loggingInMode.includes(LoggingMode.Guest) &&
    !loggingInMode.includes(LoggingMode.Sso) &&
    !loggingInMode.includes(LoggingMode.Local)
  ) {
    return AuthenticationMode.Guest;
  }

  if (
    loggingInMode.includes(LoggingMode.Sso) &&
    !loggingInMode.includes(LoggingMode.Local) &&
    !loggingInMode.includes(LoggingMode.Guest)
  ) {
    return AuthenticationMode.Sso;
  }

  if (
    loggingInMode.includes(LoggingMode.Guest) &&
    loggingInMode.includes(LoggingMode.Sso) &&
    !loggingInMode.includes(LoggingMode.Local)
  ) {
    return AuthenticationMode.GuestAndSso;
  }

  if (
    loggingInMode.includes(LoggingMode.Local) &&
    loggingInMode.includes(LoggingMode.Guest) &&
    !loggingInMode.includes(LoggingMode.Sso)
  ) {
    return AuthenticationMode.LocalAndGuest;
  }

  if (
    loggingInMode.includes(LoggingMode.Local) &&
    !loggingInMode.includes(LoggingMode.Guest) &&
    loggingInMode.includes(LoggingMode.Sso)
  ) {
    return AuthenticationMode.LocalAndSso;
  }

  if (
    loggingInMode.includes(LoggingMode.Local) &&
    loggingInMode.includes(LoggingMode.Guest) &&
    loggingInMode.includes(LoggingMode.Sso)
  ) {
    return AuthenticationMode.LocalAndGuestAndSso;
  }

  return null;
};
